import api from '../../../api';
import { UpdateScheduleRequestPayload } from '../types/request-payload';

export const createSchedule = async (
  payload?: UpdateScheduleRequestPayload | void,
) => api.post(`/schedules`, payload);

export const updateSchedule = async (
  scheduleId: number,
  payload: UpdateScheduleRequestPayload,
) => api.patch(`/schedules/${scheduleId}`, payload);

export const getSchedules = async () => api.get(`/schedules`);

export const deleteSchedule = async (scheduleId: number) =>
  api.delete(`/schedules/${scheduleId}`);

export const setDefaultSchedule = async (scheduleId: number) =>
  api.get(`/schedules/${scheduleId}/make-default`);

export type ScheduleSequenceUsageItem = {
  id: number;
  name: string;
};

export const getScheduleSequenceUsage = async (
  scheduleId: number,
): Promise<ScheduleSequenceUsageItem[]> => {
  const response = await api.get(`/schedules/${scheduleId}/sequences`);
  const payload = response?.payload ?? response;
  const sequences = payload?.sequences ?? payload ?? [];
  if (!Array.isArray(sequences)) {
    return [];
  }
  return sequences.map(
    (item: { id: number; name?: string; title?: string }) => ({
      id: item.id,
      name: item.name || item.title || `Sequence ${item.id}`,
    }),
  );
};
